import React, { useState } from 'react'
import styled from 'styled-components'
import { FiFilePlus } from 'react-icons/fi'

import { BillingItem } from './billing-item'
import { EditBilling } from '../edit-billing'
import { ViewBilling } from '../view-billing'
import { Button } from '../../../../buttons'
import { FONTS } from '../../../../../constants'

export const DataTable = React.memo(({
  isEditList,
  billings,
  editingBillings,
  editBilling,
  deleteBilling,
  updateEditingBillings,
  handleClickCreate,
  handleEditBilling,
  interpretBillingType,
  revenueAllocation,
  projectRevenue,
  projectAvailable,
}) => {
  const [expand, setExpand] = useState({})
  const [isViewing, setIsViewing] = useState({ open: false })
  const [isEditing, setIsEditing] = useState({ open: false })

  const handleExpand = idx => {
    const _expand = { ...expand }
    if (_expand[idx]) {
      delete _expand[idx]
    } else {
      _expand[idx] = true
    }
    setExpand(_expand)
  }

  const handleClickView = (index) => {
    setIsViewing({ open: true, index })
  }

  const handleClickEdit = (index) => {
    updateEditingBillings(billings)
    setIsEditing({ open: true, index })
  }

  const handleCloseEditModal = () => {
    setIsEditing({ open: false })
  }

  const handleCloseViewModal = () => {
    setIsViewing({ open: false })
  }

  return (
    <Root>
      <EditBilling
        isEdit={ isEditing.open }
        data={ editingBillings[isEditing.index] }
        editBilling={ editBilling }
        deleteBilling={ deleteBilling }
        updateEditingBillings={ updateEditingBillings }
        handleClose={ handleCloseEditModal }
        handleEditBilling={ handleEditBilling }
        editingBillings={ editingBillings }
        revenueAllocation={ revenueAllocation }
        interpretBillingType={ interpretBillingType }
        projectRevenue={ projectRevenue }
        projectAvailable={ projectAvailable }
      />
      <ViewBilling
        isView={ isViewing.open }
        data={ billings[isViewing.index] }
        handleClose={ handleCloseViewModal }
        revenueAllocation={ revenueAllocation }
        interpretBillingType={ interpretBillingType }
        projectRevenue={ projectRevenue }
        projectAvailable={ projectAvailable }
        editingBillings={ editingBillings }
      />
      <HeaderRow>
        <MilestoneCol />
        <MilestoneCol /* onClick={ () => handleSort(0) } */>
          Milestone
          {/* {renderIcon(0)} */}
        </MilestoneCol>
        <ProcessCol /* onClick={ () => handleSort(1) } */>
          Process
          {/* {renderIcon(1)} */}
        </ProcessCol>
        <ValueCol /* onClick={ () => handleSort(2) } */>
          Value&nbsp;
          <SubTitle>(Based on contract price)</SubTitle>
          {/* {renderIcon(2)} */}
        </ValueCol>
        <DateCol /* onClick={ () => handleSort(3) } */>
          Invoice Date
          {/* {renderIcon(3)} */}
        </DateCol>
        <StatusCol /* onClick={ () => handleSort(4) } */>
          Status
          {/* {renderIcon(4)} */}
        </StatusCol>
        <StatusCol />
      </HeaderRow>
      <RowWrapper>
        {billings.map((item, index) => {
          return (
            <BillingItem
              key={ index }
              index={ index }
              item={ item }
              expand={ expand }
              isEditList={ isEditList }
              handleExpand={ handleExpand }
              handleClickView={ handleClickView }
              handleClickEdit={ handleClickEdit }
              interpretBillingType={ interpretBillingType }
            />
          )
        })}
      </RowWrapper>
      { isEditList &&
      <ButtonWrapper>
        <Button
          width='100px'
          height='26px'
          theme='#28a745'
          onClick={ handleClickCreate }
          icon={ <FiFilePlus style={ { fontSize: 16 } } /> }
        >
        Add New
        </Button>
      </ButtonWrapper>
      }
    </Root>
  )
})

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const RowWrapper = styled.div`
  height: 100%;
`

const Row = styled.div`
  height: 35px;
  display: grid;
  grid-template-columns: 30px 50px 200px 9fr 2fr 2fr 2fr;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  border-top: 1px solid #EAEAEA;
  cursor: pointer;

  :nth-child(1) {
      border: none;
  }

  :hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  @media (max-width: 1024px) {
    grid-template-columns: 30px 50px 100px 9fr 1fr 2fr 1fr;
  }
`

const HeaderRow = styled(Row)`
  background: #4F4F4F;
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #FFFFFF;
  padding: 0 24px;

  :hover {
    background: #4F4F4F;
  }
`

const SubTitle = styled.span`
  height: 14px;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

const MilestoneCol = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 8px;
    font-size: 16px;
  }
`

const ProcessCol = styled(MilestoneCol)`
`

const ValueCol = styled(MilestoneCol)`
  margin-left: 24px;
`

const DateCol = styled(MilestoneCol)`
`

const StatusCol = styled(MilestoneCol)`
`

const ButtonWrapper = styled.div`
  padding: 16px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/data-table/index.js